import React, { useEffect, useState, useRef } from "react";

import Popover from '@mui/material/Popover';
import dayjs from 'dayjs';
import debounce from 'lodash.debounce';
import DatePickerField from "../../common/DatePickerDashboard";
import { Alert, Snackbar } from "@mui/material";

import ProductionReportTable from "./ProductionReportTable";
import ProductionReportCommonFilter from "./ProductionReportCommonFilter";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Menu,
  Select,
  TextField,
  Typography,
  Stack,
  Pagination,
  Autocomplete,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  exportReportAction,
  getSearchAllProductionReportAction,
getZipCodeAction } from "../../redux/actions/reportActions";
import { searchAgentAction } from "../../redux/actions/userActions";
import {
  getAllLocationsAction,
} from "../../redux/actions/agencyActions";
import { useTheme, useMediaQuery } from '@mui/material';
import NoDataFound from "../../common/NoDataFound";

const LeadSourceReport = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = useState(null);
  const [sortField, setSortField] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
  const [resetCount, setResetCount] = useState(0);
  const [resetCount2, setResetCount2] = useState(0);
  const [showColumnToggle, setShowColumnToggle] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [hasSearched, setHasSearched] = useState(false);
  const [searchError, setSearchError] = useState('');
  const [lastFilters, setLastFilters] = useState({});
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const isDownloadOpen = Boolean(downloadAnchorEl);
  const [exportType, setExportType] = useState("pdf");
  const columnToggleRef = useRef(null);

  const defaultColumns = {
    customerName: true,
    policyNumber: true,
    agentName: true,
    createdDate: true,
    effectiveDate: true,
    expiryDate: true,
    cancelDate: true,
    location: true,
    source: true,
    policyType: true,
    carrier: true,
    businessOwner: true,
    homeOwner: true,
    emailId: true,
    lineOfBusiness: true,
    phoneNumber: true,
    premium: true,
    createdBy: true,
    zipCode: true,
    status: true,
    state: true,
    term: true,
  };

  const handleDownloadClick = (e) => {
    setDownloadAnchorEl(e.currentTarget);
  };

  const handleDownloadClose = () => {
    setDownloadAnchorEl(null);
  };
  const [visibleColumns, setVisibleColumns] = useState(defaultColumns);

const buildCleanFilters = () => {
  const cleaned = Object.entries(filters).reduce((acc, [key, value]) => {
    if (value !== "" && value !== null && value !== undefined && value !== "All") {
      if (key === 'location' && value && typeof value === 'object') {
        if (value.locationId) {
          acc.locationId = value.locationId;
        } else if (value.id) {
          acc.locationId = value.id;
        }
      } else if (key === 'location' && !value) {
      } else {
        acc[key] = value;
      }
    }
    return acc;
  }, {});


  if (cleaned.phoneNumber) {
    cleaned.phoneNumber = "+1" + String(cleaned.phoneNumber).replace(/\D/g, "");
  }


  ["homeOwner", "businessOwner"].forEach((field) => {
    if (cleaned[field] === "true") cleaned[field] = true;
    else if (cleaned[field] === "false") cleaned[field] = false;
    else if (cleaned[field] === "All") delete cleaned[field];
  });


  if (cleaned.carrier) {
    cleaned.company = cleaned.carrier;
    delete cleaned.carrier;
  }


  if (dateType && dateRange.from) {
    cleaned[`${dateType}From`] = dateRange.from;
  }
  if (dateType && dateRange.to) {
    cleaned[`${dateType}To`] = dateRange.to;
  }

  return cleaned;
};

useEffect(() => {
  if (!hasSearched) return;
  runSearch(page, rowsPerPage, sortField, sortOrder);
  
}, [sortField, sortOrder]);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (columnToggleRef.current && !columnToggleRef.current.contains(event.target)) {
      setShowColumnToggle(false);
    }
  };

  if (showColumnToggle) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [showColumnToggle]);

const runSearch = (pageArg = 0, sizeArg = rowsPerPage, sortFieldArg = sortField, sortOrderArg = sortOrder) => {
  const cleaned = buildCleanFilters();

  setLastFilters(cleaned); 
  setHasSearched(true);

  const safePageSize = sizeArg && sizeArg > 0 ? sizeArg : 10;

  return dispatch(
    getSearchAllProductionReportAction(
      cleaned,
      pageArg,
      safePageSize,
      sortFieldArg,
      sortOrderArg
    )
  );
};

const handleSort = (field) => {
  const newOrder = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
  setSortField(field);
  setSortOrder(newOrder);
  setPage(0);

  if (!hasSearched) return;
  runSearch(0, rowsPerPage, field, newOrder);
};


  const [filters, setFilters] = useState({
    customerName: '',
    policyNumber: '',
    agentName: '',
    location: null,
    policyType: '',
    lineOfBusiness: null,
    source: '',
    carrier: '',
    createdDate: '',
    effectiveDate: '',
    expiryDate: '',
    cancelDate: '',
    phoneNumber: '',
    emailId:'',
    zipCode: '',
    homeOwner: '',
    businessOwner: '',
    status: null,
    state:'',
    createdBy: null,
    policyTerm: '',
    term:'',
    premium:'',
  });

  const [resetCounter, setResetCounter] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [agentSearchTerm, setAgentSearchTerm] = useState('');
  const [snackbar, setSnackbar] = useState({
  open: false,
  message: '',
  severity: 'info',
});

const [dateType, setDateType] = useState("");
const [dateRange, setDateRange] = useState({ from: null, to: null });

  const production_report_data = useSelector(
    (state) => state.allReportReducer.get_production_report.content, shallowEqual
  ) || [];
  const production_report_pagination = useSelector(
    (state) => state.allReportReducer.get_production_report || {}
  );
  const search_agent_list = useSelector(
    (state) => state.user.search_agent || {}
  );
  const get_all_location = useSelector(
    (state) => state?.agency?.get_all_locations_list || []);

  const zip_code_list = useSelector(
    (state) => state.allReportReducer.zipcode_list || {}
  );

  const agentOptions = search_agent_list.content || [];

  const handleAgentSearch = debounce((value) => {
    if (value?.length > 1) {
      dispatch(searchAgentAction(value));
    }
  }, 300);

  

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    dispatch(getAllLocationsAction());
  }, [dispatch]);

  const open = Boolean(anchorEl);
  const popoverId = open ? 'filter-popover' : undefined;



const handleFilterChange = (e) => {
    const { name, value } = e.target;

    if (name === "phoneNumber") {
      let digits = value.replace(/\D/g, "");

      if (digits.length > 3 && digits.length <= 6) {
        digits = digits.replace(/(\d{3})(\d+)/, "$1-$2");
      } else if (digits.length > 6) {
        digits = digits.replace(/(\d{3})(\d{3})(\d+)/, "$1-$2-$3");
      }

      setFilters((prev) => ({
        ...prev,
        phoneNumber: digits,
      }));
      return;
    }

    if (name === "emailId") {
      setFilters((prev) => ({
        ...prev,
        emailId: value,
      }));

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && !emailRegex.test(value)) {
        setFieldErrors((prev) => ({
          ...prev,
          emailId: "Invalid email address",
        }));
      } else {
        setFieldErrors((prev) => ({
          ...prev,
          emailId: "",
        }));
      }
      return;
    }

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePhoneBlur = () => {
    const digits = filters.phoneNumber.replace(/\D/g, "");
    if (digits && digits.length !== 10) {
      setFieldErrors((prev) => ({
        ...prev,
        phoneNumber: "Invalid phone number",
      }));
    } else {
      setFieldErrors((prev) => ({
        ...prev,
        phoneNumber: "",
      }));
    }
  };

  const handlePhoneChange = (e) => {
  let value = e.target.value.replace(/\D/g, ''); 
  if (value.length > 10) value = value.slice(0, 10); 

  if (value.length > 6) {
    value = `${value.slice(0,3)}-${value.slice(3,6)}-${value.slice(6)}`;
  } else if (value.length > 3) {
    value = `${value.slice(0,3)}-${value.slice(3)}`;
  }

  setFilters(prev => ({
    ...prev,
    phoneNumber: value
  }));
};

  useEffect(() => {
    if (page > 0 && production_report_pagination.totalPages > 0 && page >= production_report_pagination.totalPages) {
      setPage(0);
    }
  }, [production_report_pagination.totalPages]);

const handleSubmit = () => {
  const hasAnyFilter =
    Object.values(filters).some(v => v !== '' && v !== null && v !== undefined) ||
    (dateType && (dateRange.from || dateRange.to));

  if (!hasAnyFilter) {
    setSearchError("Please fill at least one search field.");
    return;
  }

  setSearchError("");
  setPage(0);
  runSearch(0, rowsPerPage); 
};


const handleExport = async (formatParam) => {
  const fmt = formatParam || exportType;
  try {
    setSnackbar({
      open: true,
      message: `Generating ${fmt.toUpperCase()}...`,
      severity: 'info',
    });

    const cleanedFilters = buildCleanFilters();
    const exportFilters = { ...cleanedFilters };
    
    if (dateType && dateRange.from) {
      exportFilters[`${dateType}From`] = dayjs(dateRange.from).format("MM-DD-YYYY");
    }
    if (dateType && dateRange.to) {
      exportFilters[`${dateType}To`] = dayjs(dateRange.to).format("MM-DD-YYYY");
    }

    await dispatch(exportReportAction(exportFilters, fmt, sortField, sortOrder));

    setSnackbar({
      open: true,
      message: `${fmt.toUpperCase()} exported successfully!`,
      severity: 'success',
    });
  } catch (error) {
    console.error('Export Error:', error);
    setSnackbar({
      open: true,
      message: `Failed to export ${formatParam?.toUpperCase() || exportType.toUpperCase()}. Please try again.`,
      severity: 'error',
    });
  } finally {
    handleDownloadClose();
  }
};


  const handleReset = () => {
    setFilters({
      customerName: '',
      policyNumber: '',
      agentName: '',
      location: null,
      policyType: '',
      lineOfBusiness: null,
      source: '',
      carrier: '',
      createdDate: '',
      effectiveDate: '',
      expiryDate: '',
      cancelDate: '',
      phoneNumber: '',
      emailId:'',
      zipCode: '',
      homeOwner: '',
      businessOwner: '',
      status: null,
      createdBy: null,
      policyTerm: '',
      term:'',
      premium:'',
    });
    
    setFieldErrors({});
    setHasSearched(false);
    setSearchError('');
    setPage(0);
    setDateType("");
    setDateRange({ from: null, to: null });
    setResetCounter((prev) => prev + 1);
    setSortField('');
    setSortOrder('asc');
    setResetCount(prev => prev + 1);
    setResetCount2(prev => prev + 1);
  };

const handleChangePage = (event, newPage) => {
  setPage(newPage);
  if (!hasSearched) return;
  runSearch(newPage, rowsPerPage);
};

const handleChangeRowsPerPage = (event) => {
  const newSize = parseInt(event.target.value, 10);
  setRowsPerPage(newSize);
  setPage(0);
  if (!hasSearched) return;
  runSearch(0, newSize);
};

const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  const cleaned = ('' + phone).replace(/\D/g, '');

  if (cleaned.length === 10) {
    
    return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
  }

  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    
    return `${cleaned.substring(1, 4)}-${cleaned.substring(4, 7)}-${cleaned.substring(7)}`;
  }

  return phone; 
};

  const handleZipSearch = debounce((value) => {
    if (value?.length >= 2) {
      dispatch(getZipCodeAction(value));
    }
  }, 300);

  useEffect(() => {
    const saved = localStorage.getItem('visible_columns');
    if (saved) {
      setVisibleColumns(JSON.parse(saved));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('visible_columns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

   const uniqueLocations = Array.from(new Map(
    get_all_location.map(item => [item.locationDescription, item])
  ).values());

  return (
    <Box sx={{
      padding: isMobile ? '8px' : '24px',
      overflowX: 'auto',
      backgroundColor: '#ffffff',
      minHeight: '40vh',
	    marginBottom: '120px',
          '@media (min-width: 768px) and (max-width: 1024px)': {
            minHeight: '40vh',
            height: 'auto',
            overflowY: 'auto',
          },
          '@media (min-width: 1024px) and (min-height: 1366px)': {
            height: 'auto',
            minHeight: '80vh',
          },
    }}>
      {/* Header Section */}
      <Box sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
        alignItems: isMobile ? "flex-start" : "center",
        marginBottom: '16px',
        flexWrap: 'wrap',
        gap: 2
      }}>
    <Typography
       variant="h2"
          id="leadsource"
          sx={{
            margin: isMobile ? "10px 0" : "30px 0 10px 0",
            ml:2
          }}
          gutterBottom
        >
         Report : Production Report
        {hasSearched && ` (${production_report_pagination.totalElements || 0})`}

        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>      
          <Box sx={{ display: "flex", gap: 2,}}>
            <Button
              variant="contained"
              aria-controls={isDownloadOpen ? 'download-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={isDownloadOpen ? 'true' : undefined}
              onClick={handleDownloadClick}
              disabled={!hasSearched}
            >
              Download
            </Button>

            <Menu
              id="download-menu"
              anchorEl={downloadAnchorEl}
              open={isDownloadOpen}
              onClose={handleDownloadClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <MenuItem onClick={() => handleExport('pdf')}>PDF</MenuItem>
              <MenuItem onClick={() => handleExport('xlsx')}>Excel (XLSX)</MenuItem>
              <MenuItem onClick={() => handleExport('csv')}>CSV</MenuItem>
            </Menu>
          </Box>


          <Button
            variant="outlined"
            aria-describedby={popoverId}
            onClick={handleFilterClick}
          >
            Filter
          </Button>
          <Button
            variant="outlined"
            onClick={() => setShowColumnToggle((prev) => !prev)}
          >
            Select Columns
          </Button>
        </Box>

        {showColumnToggle && (
          <Box
           ref={columnToggleRef}
            sx={{
              position: 'absolute',
              top: isMobile ? 180 : 200,
              right: isMobile ? 10 : 30,
              zIndex: 10,
              backgroundColor: 'white',
              border: '1px solid #ccc',
              borderRadius: 2,
              padding: 2,
              boxShadow: 3,
              maxHeight: 400,
              overflowY: 'auto',
              maxWidth: isMobile ? '180px' : '200px'
            }}
          >
            <Typography fontWeight={600} mb={1}>Select Columns</Typography>
            {Object.keys(defaultColumns).map((column) => (
              <FormControlLabel
                key={column}
                control={
                  <Checkbox
                    checked={visibleColumns[column]}
                    onChange={() =>
                      setVisibleColumns((prev) => ({
                        ...prev,
                        [column]: !prev[column],
                      }))
                    }
                    size={isMobile ? "small" : "medium"}
                  />
                }
                label={
                  <Typography fontSize={isMobile ? "12px" : "14px"}>
                    {column.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())}
                  </Typography>
                }
              />
            ))}
          </Box>
        )}

        <Popover
          id={popoverId}
          open={open}
          anchorEl={anchorEl}
          onClose={handleFilterClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          sx={{
            "& .MuiPaper-root": {
              width: isMobile ? "100%" : "auto",
              maxWidth: isMobile ? "100%" : "1000px",
            },
          }}
        >
          <Box sx={{ p: 2 }}>
            {/* ✅ Wrap all in a container */}
            <Grid container spacing={2}>
              {/* Date Type Selector */}
              <Grid item xs={12} sm={6} md={3}>
                <label
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    display: "block",
                    marginBottom: 4,
                  }}
                >
                  Date Type
                </label>
                <Select
                  fullWidth
                  value={dateType}
                  onChange={(e) => {
                    setDateType(e.target.value);
                    setDateRange({ from: null, to: null }); 
                  }}
                  displayEmpty
                >
                  <MenuItem value="">Select Date Type</MenuItem>
                  <MenuItem value="created">Created Date</MenuItem>
                  <MenuItem value="effective">Effective Date</MenuItem>
                  <MenuItem value="expiration">Expiration Date</MenuItem>
                  <MenuItem value="cancel">Cancelled Date</MenuItem>
                </Select>
              </Grid>

              {/* From/To filters based on dateType */}
              {dateType && (
                <>
                  <Grid item xs={12} sm={6} md={3}>
                    <label
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        display: "block",
                        marginBottom: 4,
                      }}
                    >
                      {dateType.charAt(0).toUpperCase() + dateType.slice(1)} From
                    </label>
                    <DatePickerField
                      fieldName="from"
                      formData={dateRange}
                      handleDateChange={(name, value) =>
                        setDateRange((prev) => ({ ...prev, from: value }))
                      }
                      handleBlur={() => {}}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <label
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        display: "block",
                        marginBottom: 4,
                      }}
                    >
                      {dateType.charAt(0).toUpperCase() + dateType.slice(1)} To
                    </label>
                    <DatePickerField
                      fieldName="to"
                      formData={dateRange}
                      handleDateChange={(name, value) =>
                        setDateRange((prev) => ({ ...prev, to: value }))
                      }
                      handleBlur={() => {}}
                    />
                  </Grid>
                </>
              )}


<Grid item xs={12} sm={6} md={3}>
            <label htmlFor="location-autocomplete" style={{ fontSize: 14, fontWeight: 500, display: 'block', marginBottom: 4 }}>
                  Location
                </label>
                <Autocomplete
                  id="location-autocomplete"
                  freeSolo
              key={`location-${resetCount}`}
              options={uniqueLocations}
              getOptionLabel={(option) =>
                typeof option === 'string'
                  ? option
                  : option.locationDescription || ''
              }
              isOptionEqualToValue={(option, value) => {
                const optionId = typeof option === 'string' ? option : option.id;
                const valueId = typeof value === 'string' ? value : value.id;
                return optionId === valueId;
              }}
              renderOption={(props, option) => {
                const { key, ...otherProps } = props;
                return (
                  <li key={option.id || option.locationDescription} {...otherProps}>
                    {option.locationDescription}
                  </li>
                );
              }}
                onChange={(e, newValue) => {
                  setFilters((prev) => ({
                    ...prev,
                    location: newValue 
                  }));
                }}
              value={filters.location || null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size={isMobile ? "small" : "medium"}
                  placeholder="Select Location"
                  sx={{
                    width: '100%',
                    '& .MuiInputBase-root': {
                      height: isMobile ? '40px' : '55px'
                    }
                  }}
                />
              )}
            />
          </Grid>

           <Grid item xs={12} sm={6} md={3}>
            <label
              htmlFor="zipcode-autocomplete"
              style={{
                fontSize: 14,
                fontWeight: 500,
                display: "block",
                marginBottom: 4,
              }}
            >
              Zip Code
            </label>
            <Autocomplete
              id="zipcode-autocomplete"
              freeSolo
              key={`zipCode-${resetCount2}`}
              options={zip_code_list}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.zipCode || ""
              }
              renderOption={(props, option) => <li {...props}>{option.zipCode} - {option.cityName}, {option.stateCode} </li>}
              onInputChange={(e, newInputValue) => {
                
                if (/^\d{0,5}$/.test(newInputValue)) {
                  setFilters((prev) => ({
                    ...prev,
                    zipCode: newInputValue,
                  }));
                  handleZipSearch(newInputValue);
                }
              }}
              onChange={(e, newValue) => {
                const zip =
                  typeof newValue === "string" ? newValue : newValue?.zipCode || "";
                if (/^\d{0,5}$/.test(zip)) {
                  setFilters((prev) => ({
                    ...prev,
                    zipCode: zip,
                  }));
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size={isMobile ? "small" : "medium"}
                  placeholder="Search ZIP Code"
                  value={filters.zipCode}
                  fullWidth
                  onKeyPress={(e) => {
                    
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  inputProps={{
                    ...params.inputProps,
                    inputMode: "numeric", 
                    maxLength: 5, 
                  }}
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-root": {
                      height: isMobile ? "40px" : "55px",
                    },
                  }}
                />
              )}
            />
          </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <label htmlFor="agent-autocomplete" style={{ fontSize: 14, fontWeight: 500, display: 'block', marginBottom: 4 }}>
                  Agent Name
                </label>
                <Autocomplete
                  id="agent-autocomplete"
                options={agentOptions}
                getOptionLabel={(option) =>
                  typeof option === 'string'
                    ? option
                    : `${option.firstName || ''} ${option.lastName || ''}`
                }
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  if (typeof option === 'string' && typeof value === 'string') {
                    return option === value;
                  }
                  if (typeof option === 'object' && typeof value === 'object') {
                    return option.id === value.id;
                  }
                  return false;
                }}
                renderOption={(props, option) => {
                  const { key, ...otherProps } = props;
                  return (
                    <li key={option.id} {...otherProps}>
                      {option.firstName} {option.lastName}
                    </li>
                  );
                }}
                onInputChange={(e, newInputValue) => {
                  setAgentSearchTerm(newInputValue);
                  handleAgentSearch(newInputValue);
                }}
                onChange={(e, newValue) => {
                  setFilters((prev) => ({
                    ...prev,
                    assignedTo: newValue || '' 
                  }));
                }}
                value={filters.assignedTo || null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size={isMobile ? "small" : "medium"}
                    placeholder="Search Agent"
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-root': {
                        height: isMobile ? '40px' : '55px'
                      }
                    }}
                  />
                )}
              />
            </Grid>
                {[
                  {
                    label: 'Line of Business',
                    name: 'lineOfBusiness',
                    options: ['All', 'Personal Auto', 'Commercial Auto', 'Homeowners', 'Health', 'General Liability'],
                  },
                  {
                    label: 'Policy Type',
                    name: 'policyType',
                    options: ['All', 'New Business', 'Renewal', 'Rewrite'],
                  },
                  {
                    label: 'Source',
                    name: 'source',
                    options: ['All', 'Walk-ins', 'Direct Mail', 'Email', 'Referrals'],
                  },
                  {
                    label: 'Carrier',
                    name: 'carrier',
                    options: ['All', 'National General', 'Assurance America', 'United Auto', 'Pearl'],
                  },
                  {
                    label: 'Home Owner',
                    name: 'homeOwner',
                    options: ['All', 'true', 'false'],
                  },
                  {
                    label: 'Business Owner',
                    name: 'businessOwner',
                    options: ['All', 'true', 'false'],
                  },
                  {
                    label: 'Status',
                    name: 'status',
                    options: ['All', 'Active', 'Cancelled', 'Pending Cancellation', 'Expired'],
                  },
                  {
                    label: 'Policy Term',
                    name: 'term',
                    options: ['All', 'Semi Annual', 'Annual'],
                  },
                ].map((field) => (
                  <Grid key={field.name} item xs={12} sm={6} md={3}>
                    <label htmlFor={`${field.name}-autocomplete`} style={{ fontSize: 14, fontWeight: 500, display: 'block', marginBottom: 4 }}>
                      {field.label}
                    </label>
                    <Autocomplete
                      id={`${field.name}-autocomplete`}
                      fullWidth
                      options={field.options}
                      value={
                        filters[field.name] === "" ? null : filters[field.name]  
                      }
                      onChange={(e, newValue) => {
                        setFilters((prev) => ({
                          ...prev,
                          [field.name]: newValue || "",   
                        }));
                      }}
                      getOptionLabel={(option) => {
                        if (option === "true") return "Yes";
                        if (option === "false") return "No";
                        return option || "";
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size={isMobile ? "small" : "medium"}
                          placeholder={`Select ${field.label}`}  
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              height: isMobile ? "40px" : "55px",
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                ))}

              <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1}>
                <Button
                  variant="outlined"
                  onClick={handleReset}
                >
                  Reset
                </Button>
                <Button
                  onClick={() => {
                    handleSubmit();
                    handleFilterClose();
                  }}
                  variant="outlined"
                >
                  Search
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Popover>
      </Box>

      {/* Search Section */}
      <ProductionReportCommonFilter
        filters={filters}
        handleFilterChange={handleFilterChange}
        handlePhoneBlur={handlePhoneBlur}
        handlePhoneChange={handlePhoneChange}
        fieldErrors={fieldErrors}
        isMobile={isMobile}
        searchError={searchError}
        resetCounter={resetCounter}
        handleSubmit={handleSubmit}
        hasSearched={hasSearched}
        handleReset={handleReset}  
        />

     {!hasSearched ? (
     
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '200px',
          backgroundColor: '#f9f9f9',
          borderRadius: 2,
          border: '1px solid #e0e0e0'
        }}>
          <NoDataFound discription={"Please use the search filters above to fetch and display updated Production Report data."} />
        </Box>
        ) : production_report_data.length === 0 ? (
         
          <Box sx={{ textAlign: 'center', p: 3 }}>
            <NoDataFound discription={"Please use the search filters above to fetch and display updated Production Report data."} />
          </Box>
        ) : (
        <ProductionReportTable
          sortOrder={sortOrder}
          visibleColumns={visibleColumns}
          production_report_data={production_report_data}
          sortField={sortField}
          handleSort={handleSort}
          isMobile={isMobile}
        />
      )}

    {hasSearched && production_report_pagination?.totalElements > 0 && (
        <Box sx={{
          width: '100%',
          overflow: 'hidden',
          padding: '16px 0'
        }}>
          <Stack
            direction={isMobile ? 'column' : 'row'}
            justifyContent="flex-end"
            alignItems="center"
            flexWrap="wrap"
            spacing={2}
          >
            {/* Rows per page dropdown */}
            <Box display="flex" alignItems="center">
              <Typography variant="body2" sx={{ fontSize: '14px', marginRight: '8px' }}>
                Rows per page:
              </Typography>
              <Select
                name="rowsPerPage"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                size="small"
                sx={{
                  fontSize: isMobile ? '12px' : '14px',
                  minWidth: isMobile ? '70px' : '80px',
                }}
              >
                {[5, 10, 15, 25, 50, 100].map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            {production_report_data && production_report_data.length > 0 && (
            <Pagination
              count={production_report_pagination.totalPages}
              page={page + 1}
              onChange={(e, value) => handleChangePage(e, value - 1)}
              showFirstButton
              showLastButton
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 0 : 1}
              size={isMobile ? "small" : "medium"}
            />
            )}
          </Stack>
        </Box>
      )}
      <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default LeadSourceReport;